module.exports = __webpack_public_path__ + "img/debg.e2222945.jpg";